import Affiliate from './Affiliate';
import PHPCookie from './PHPCookie';

export default class CommissionFactory extends Affiliate {
  constructor() {
    super();
    this.affiliateName = 'commission-factory';
    this.cookieDomain = new PHPCookie();
    this.cookieNames = ['serverToServerAffiliate', 'serverToServerClickId'];
    this.validStores = ['PBAU', 'PBCA', 'PBID', 'PBMY', 'PBPH', 'PBSG', 'PBTW', 'PBTH', 'PBUK', 'PBUS'];
  }

  prepareCookie() {
    const { cfclick } = this.urlParams;
    this.cookieDomain.sendCookie({ name: 'serverToServerAffiliate', value: 'commission-factory', httponly: 1 });
    this.cookieDomain.sendCookie({ name: 'serverToServerClickId', value: cfclick, httponly: 1 });
  }
}



// WEBPACK FOOTER //
// ./src/Common/Helpers/TrackingAffiliate/CommissionFactory.js